import { Capacitor } from '@capacitor/core';
import { captureException } from '@sentry/react';

import { appsFlyerBuffer } from './appsflyer.buffer';
import { AppsFlyerNativeSDK } from './appsflyer.native';
import { AppsFlyerApi } from './appsflyer.types';
import { AppsFlyerWebSDK } from './appsflyer.web';

type AppsFlyerInitParams = {
  appId: string;
  devKey: string;
  webDevKey: string | null;
};

export const getAppsFlyerSdk = async ({ appId, devKey, webDevKey }: AppsFlyerInitParams) => {
  let AppsFlyer: AppsFlyerApi | null = null;

  try {
    if (Capacitor.getPlatform() === 'web' && webDevKey) {
      AppsFlyer = await AppsFlyerWebSDK.getSdk(webDevKey);
    }

    if (Capacitor.isNativePlatform()) {
      AppsFlyer = await AppsFlyerNativeSDK.getSDK({
        devKey,
        appId,
      });
    }

    if (AppsFlyer) {
      // Execute any methods that were called before the SDK was initialized
      appsFlyerBuffer.sendBufferedEvents(AppsFlyer);
      // Clear the appsFlyerBuffer after executing all methods
      appsFlyerBuffer.clearBuffer();
    }

    return AppsFlyer;
  } catch (error) {
    captureException(`AppsFlyer SDK initialization failed: ${error instanceof Error ? error.message : String(error)}`);
    return null;
  }
};
